window.VegasCatalog = {
	popup: function (text, params = {}) {
		let defaults = {
			"positionClass": "toast-bottom-center",
			'preventDuplicates': true
		};

		/*Toastr.options = Object.assign(defaults, params);
		Toastr.success(text);*/
	}
};

require('./_cart');
require('./_order');
require('./_input-counter');
